import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'surface rounded-lg p-12 text-center flex flex-col items-center gap-2',
        className,
      )}
    >
      <p className="text-breaker-ink-2 font-medium">{title}</p>
      {description ? (
        <p className="text-sm text-breaker-mute max-w-md">{description}</p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
